function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Api from "../ajax/InformationApi";
import * as Utility from "../commons/Utility";
import * as InformationModalComponent from "./InformationModalComponent";
import { NullNumberToBlank } from "../commons/Utility";
import { ApiResultCodes } from "../enum/ApiResultCodes";
import IntlMessage from '../commons/Intl';
import { Placeholder, Informations, OrganizationScopes, NotifyStatus } from '../commons/IntlMessages';
import { NotifyStatuses } from "../enum/NotifyStatuses";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
/**
 * メインコンポーネント
 */

var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      Selected: null,
      OrganizationId: 0,
      InformationList: [],
      InformationModalMode: InformationModalComponent.Mode.None,
      SearchText: "",
      CurrentPage: 1,
      DataCount: 0,
      DataAllCount: 0
    };

    _this.GetList(_this.state.CurrentPage);

    return _this;
  }
  /**
   * 対象の検索テキストを更新します。
   *
   * @param e イベント
   */


  _createClass(MainComponent, [{
    key: "updateSearchText",
    value: function updateSearchText(e) {
      this.setState({
        SearchText: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * リスト表示
     */

  }, {
    key: "GetList",
    value: function GetList(pageNum) {
      var _this2 = this;

      Api.Query(this.state.SearchText, (pageNum - 1) * this.props.pageSize + 1, this.props.pageSize, function (data) {
        _this2.setState({
          Selected: null,
          OrganizationId: data.OrganizationId,
          InformationList: data.InformationList,
          DataCount: data.Count,
          DataAllCount: data.AllCount
        });
      });
    }
    /**
     * 前ページ表示
     */

  }, {
    key: "previousPage",
    value: function previousPage() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      var page = 0;

      if (this.state.CurrentPage <= 1) {
        page = 1;
      } else {
        page = this.state.CurrentPage - 1;
      }

      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * 次ページ表示
     */

  }, {
    key: "nextPage",
    value: function nextPage() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      var page = 0;
      var maxPage = Math.ceil(this.state.DataCount / this.props.pageSize);

      if (maxPage == 0) {
        page = 1;
      } else if (this.state.CurrentPage >= maxPage) {
        page = maxPage;
      } else {
        page = this.state.CurrentPage + 1;
      }

      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * お知らせモーダルを追加で起動します。
     */

  }, {
    key: "openAddInformationModal",
    value: function openAddInformationModal() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      this.setState({
        InformationModalMode: InformationModalComponent.Mode.Add
      });
    }
    /**
     * お知らせモーダルを編集で起動します。
     */

  }, {
    key: "openModifyInformationModal",
    value: function openModifyInformationModal(m) {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      this.setState({
        InformationModalMode: InformationModalComponent.Mode.Modify,
        Selected: {
          InformationId: m.InformationId,
          Title: m.Title,
          Contents: m.Contents,
          StartDateTime: m.StartDateTime,
          EndDateTime: m.EndDateTime,
          OrganizationId: m.OrganizationId,
          Notified: m.Notified,
          Readed: m.Readed,
          UpdateDateTime: m.UpdateDateTime
        }
      });
    }
    /**
     * お知らせを検索します。
     *
     * @param searchText 検索文字列
     */

  }, {
    key: "searchInformation",
    value: function searchInformation() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      var page = 1;
      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * お知らせを登録します。
     *
     * @param title タイトル
     * @param content 内容
     * @param startDateTime 公開開始日
     * @param endDateTime 公開終了日
     * @param organizationId 組織ID
     * @param closeEvent 終了処理
     */

  }, {
    key: "entryInformationModal",
    value: function entryInformationModal(title, content, startDateTime, endDateTime, organizationId, closeEvent) {
      var _this3 = this;

      Api.AddInformation(title, content, startDateTime, endDateTime, organizationId, function (data) {
        _this3.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          closeEvent();

          _this3.GetList(_this3.state.CurrentPage);
        }
      });
    }
    /**
     * お知らせを更新します。
     *
     * @param id お知らせID
     * @param title タイトル
     * @param content 内容
     * @param startDateTime 公開開始日
     * @param endDateTime 公開終了日
     * @param organizationId 組織ID
     * @param updateDateTime 更新日時
     * @param closeEvent 終了処理
     */

  }, {
    key: "modifyInformationModal",
    value: function modifyInformationModal(id, title, content, startDateTime, endDateTime, organizationId, updateDateTime, closeEvent) {
      var _this4 = this;

      Api.ModifyInformation(id, title, content, startDateTime, endDateTime, organizationId, updateDateTime, function (data) {
        _this4.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          closeEvent();

          _this4.GetList(_this4.state.CurrentPage);
        }
      });
    }
    /**
     * お知らせを削除します。
     *
     * @param id お知らせID
     * @param updateDateTime 更新日時
     */

  }, {
    key: "deleteInformationModal",
    value: function deleteInformationModal(id, updateDateTime) {
      var _this5 = this;

      Api.DeleteInformation(id, updateDateTime, function (data) {
        _this5.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          _this5.GetList(_this5.state.CurrentPage);
        }
      });
    }
    /**
     * お知らせを既読にします。
     *
     */

  }, {
    key: "closeInformationModal",
    value: function closeInformationModal() {}
    /**
     * お知らせモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenInformationModal",
    value: function hiddenInformationModal() {
      this.setState({
        InformationModalMode: InformationModalComponent.Mode.None
      });
    }
    /**
     * 組織範囲を戻します。
     *
     * @param organizationScope 組織範囲
     */

  }, {
    key: "getOrganizationScope",
    value: function getOrganizationScope(organizationScope) {
      if (organizationScope == 0) return intl.format(OrganizationScopes.All);else return intl.format(OrganizationScopes.OnlyThis);
    }
    /**
     * 通知状態表示名取得
     *
     * @param notified 通知状態
     */

  }, {
    key: "getNotifyStatusName",
    value: function getNotifyStatusName(notified) {
      switch (notified) {
        case NotifyStatuses.NotNotified:
          return intl.format(NotifyStatus.NotNotified);

        case NotifyStatuses.Notified:
          return intl.format(NotifyStatus.Notified);

        case NotifyStatuses.ReNotificationRequired:
          return intl.format(NotifyStatus.ReNotificationRequired);

        default:
          return "";
      }
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.common.bind();
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        id: "overlay"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cv-spinner"
      }, /*#__PURE__*/React.createElement("span", {
        className: "spinner"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 offset-1 col-lg-6 offset-lg-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement("img", {
        width: "60",
        height: "60",
        src: "/assets/img/Icon_ManageNotification_Gray.svg"
      }), /*#__PURE__*/React.createElement("h2", null, intl.format(Informations.Title)))), /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-10 offset-1 col-lg-6 offset-lg-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-top"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control-search",
        name: "search",
        maxLength: 50,
        onChange: function onChange(e) {
          return _this6.updateSearchText(e);
        },
        value: this.state.SearchText,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.SearchWord)
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-6 search-btn"
      }, /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.searchInformation.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Search"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "36",
        height: "36",
        src: "/assets/img/search_icon.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right"
      }, /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.openAddInformationModal.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Add information"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "36",
        height: "36",
        src: "/assets/img/add_icon.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right paging-btn"
      }, this.state.CurrentPage <= 1 && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage > 1 && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.previousPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage >= Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      })), this.state.CurrentPage < Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.nextPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-middle"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "col-12 list-group list-group-flush"
      }, this.state.InformationList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "list-group-item",
          key: x.InformationId
        }, /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-1"
        }, (_this6.state.CurrentPage - 1) * _this6.props.pageSize + _i + 1), /*#__PURE__*/React.createElement("div", {
          className: "col-5 cursorpointer",
          style: {
            wordWrap: "break-word"
          },
          onClick: _this6.openModifyInformationModal.bind(_this6, x)
        }, x.Title), /*#__PURE__*/React.createElement("div", {
          className: "col-2 cursorpointer",
          onClick: _this6.openModifyInformationModal.bind(_this6, x)
        }, Utility.ToMoment(x.StartDateTime).format("YYYY-MM-DD")), /*#__PURE__*/React.createElement("div", {
          className: "col-2 cursorpointer",
          onClick: _this6.openModifyInformationModal.bind(_this6, x)
        }, _this6.getOrganizationScope(x.OrganizationId)), /*#__PURE__*/React.createElement("div", {
          className: "col-2 cursorpointer",
          onClick: _this6.openModifyInformationModal.bind(_this6, x)
        }, _this6.getNotifyStatusName(x.Notified))));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-bottom"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-1 offset-10 text-right"
      }, /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.openAddInformationModal.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Add information"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "36",
        height: "36",
        src: "/assets/img/add_icon.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right paging-btn"
      }, this.state.CurrentPage <= 1 && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage > 1 && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.previousPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage >= Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      })), this.state.CurrentPage < Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.nextPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      }))))))), this.state.InformationModalMode != InformationModalComponent.Mode.None && /*#__PURE__*/React.createElement(InformationModalComponent["default"], {
        mode: this.state.InformationModalMode,
        currentOrganizationId: this.state.OrganizationId,
        informationId: NullNumberToBlank(this.state.Selected ? this.state.Selected.InformationId : null),
        title: this.state.Selected ? this.state.Selected.Title : "",
        contents: this.state.Selected ? this.state.Selected.Contents : "",
        startDateTime: this.state.Selected ? this.state.Selected.StartDateTime : null,
        endDateTime: this.state.Selected ? this.state.Selected.EndDateTime : null,
        organizationId: this.state.Selected ? this.state.Selected.OrganizationId : null,
        readed: this.state.Selected ? this.state.Selected.Readed : 0,
        updateDateTime: this.state.Selected ? this.state.Selected.UpdateDateTime : "",
        onEntry: this.entryInformationModal.bind(this),
        onModify: this.modifyInformationModal.bind(this),
        onDelete: this.deleteInformationModal.bind(this),
        onClose: this.closeInformationModal.bind(this),
        onHidden: this.hiddenInformationModal.bind(this)
      }));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 * @param pageSize ページサイズ
 */


export default function (el, common, pageSize) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common,
    pageSize: pageSize
  }), el);
}